'use es6';

import { fromJS, List } from 'immutable';
import { getPatternFormat } from '../../../constants/colors';
import { getPropertyFormatter } from '../../../formatters/propertyFormatter';
import { DataLabelFormats } from '../../commonRecords';
import { SeriesStyle, MarkTypes } from '../xyRecords';
export const getMultiMeasureSeriesOptions = ({
  chart,
  layers,
  inverted,
  stackLabels,
  dataLabels: showDataLabels
}) => {
  const {
    series = List()
  } = chart;
  const chartType = chart.getIn(['options', 'type']);
  const dataLabelFormat = chart.getIn(['options', 'dataLabelFormat']);
  return series.map(({
    index,
    id,
    layerId,
    property,
    name,
    type,
    xAxis,
    yAxis,
    stacking,
    stack,
    points,
    style,
    events
  }) => {
    type = type || chartType;
    style = style || SeriesStyle({});
    let categoryField = inverted ? layers.getIn([layerId, 'y', 'field']) : layers.getIn([layerId, 'x', 'field']);
    let typeIsDatetime = layers.getIn([layerId, 'dataset', 'properties', categoryField, 'type']) === 'datetime';

    //Provides better Scatter date formatting
    if (layers.getIn([layerId, 'detail']) !== undefined) {
      const detailField = layers.getIn([layerId, 'detail', 'field']);
      if (layers.getIn([layerId, 'dataset', 'properties', detailField, 'type']) === 'datetime') {
        categoryField = detailField;
        typeIsDatetime = true;
      }
    }
    const seriesDates = typeIsDatetime ? points.map(point => point.getIn(['row', categoryField])) : undefined;
    const data = points.map(point => point.get('value'));
    const formatNumber = getPropertyFormatter(property);
    // Ask RaaS before changing forceStacking
    // const outside = style.get('forceStacking');
    const hideDataLabels = layers.getIn([layerId, 'hideDataLabels']);
    const dataLabels = hideDataLabels ? {
      enabled: false
    } : Object.assign({
      enabled: stackLabels || showDataLabels
    }, {
      inside: false
    }, {
      formatter() {
        const seriesType = this.point.series.userOptions.type;
        switch (seriesType) {
          case MarkTypes.scatter:
          case MarkTypes.bubble:
            {
              const x = this.x;
              const y = this.y;
              const z = this.point.options.z;
              switch (dataLabelFormat) {
                case DataLabelFormats.X:
                  return formatNumber(x);
                case DataLabelFormats.Y:
                  return formatNumber(y);
                case DataLabelFormats.SIZE:
                  return formatNumber(z);
                case DataLabelFormats.X_Y:
                  return `(${formatNumber(x)}, ${formatNumber(y)})`;
                case DataLabelFormats.X_Y_SIZE:
                  return `(${formatNumber(x)}, ${formatNumber(y)}, ${formatNumber(z)})`;
                default:
                  return `(${formatNumber(x)}, ${formatNumber(y)})`;
              }
            }
          default:
            {
              if (stackLabels) {
                const totalValue = this.total;
                const formattedNumber = formatNumber(totalValue);
                return formattedNumber;
              }
              const value = this.y;
              return formatNumber(value);
            }
        }
      }
    });
    const seriesColor = style.get('pattern') && type !== 'line' ? getPatternFormat(style.get('pattern'), style.get('color')) : style.get('color');
    const styles = Object.assign({
      zIndex: style.get('zIndex') || index,
      color: seriesColor
    }, {
      marker: style.get('marker') || {}
    }, {
      pointWidth: style.get('pointWidth'),
      dashStyle: style.get('dashStyle'),
      showInLegend: style.get('showInLegend')
    });
    return fromJS(Object.assign({
      id,
      layerId,
      name,
      type,
      xAxis,
      yAxis,
      stacking,
      stack,
      data,
      dataLabels,
      legendIndex: index,
      events: events || {},
      formatNumber,
      seriesDates
    }, styles));
  });
};